import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
import { SecuritiesRemoved, SecurityReplacements } from "../Shared";
const ProjectedYearsFromNow = z.string();
const MonteCarloSimulation = z.record(ProjectedYearsFromNow, z.number());
const MonteCarloSimulationResults = z.object({
    results5Pct: MonteCarloSimulation.nullable(),
    results10Pct: MonteCarloSimulation.nullable(),
    results50Pct: MonteCarloSimulation.nullable(),
    results90Pct: MonteCarloSimulation.nullable(),
    results95Pct: MonteCarloSimulation.nullable(),
});
const GetProjectionsRes = z.object({
    monteCarloSimulationResults: MonteCarloSimulationResults,
    securityReplacements: SecurityReplacements.nullable(),
    securitiesRemoved: SecuritiesRemoved.nullable(),
});
export const getProjectionsV4KeyMaker = (accountGroupId) => [url(accountGroupId)];
export const url = (accountGroupId) => {
    return environment() === "PROD"
        ? `https://middleware.prod.farther.com/account-groups/v4/account-groups/${accountGroupId}/projections`
        : `https://middleware.uat.farther.com/account-groups/v4/account-groups/${accountGroupId}/projections`;
};
export default async function getProjectionsV4(accountGroupId, config) {
    const { data } = await axios.get(url(accountGroupId), {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            ...("advisorId" in config && { Advisor: config.advisorId }),
            ...("clientId" in config && { Client: config.clientId }),
        },
    });
    const decoded = GetProjectionsRes.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = "getProjectionsV4 returned unexpected data.";
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getProjectionsV4.js.map